/** Floto's mark and name, at the top of a printed document. */
export function Wordmark() {
  return (
    <span className="flex items-center gap-2">
      <img
        alt=""
        aria-hidden="true"
        className="size-6"
        src="/icons/icon-32.png"
        srcSet="/icons/icon-32.png 1x, /icons/icon-128.png 4x"
      />
      <span className="text-ui-lg font-semibold tracking-tight text-text-primary">
        Floto
      </span>
    </span>
  );
}
